import { render } from "./SjaakSignature.vue?vue&type=template&id=41bd52de&scoped=true"
import script from "./SjaakSignature.vue?vue&type=script&lang=js"
export * from "./SjaakSignature.vue?vue&type=script&lang=js"

import "./SjaakSignature.vue?vue&type=style&index=0&id=41bd52de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41bd52de"]])

export default __exports__